export const iconFontAwesomeMovingTrailer = (
	<i className="fa-solid fa-trailer"></i>
);
